/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Coach } from '../models/Coach';
import type { CoachCreate } from '../models/CoachCreate';
import type { CoachPatch } from '../models/CoachPatch';
import type { CoachSmallList } from '../models/CoachSmallList';
import type { CoachTypeEnum } from '../models/CoachTypeEnum';
import type { MatchCoaches } from '../models/MatchCoaches';
import type { Player } from '../models/Player';
import type { Referee } from '../models/Referee';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CoachService {
    /**
     * Get Coach
     * @param coachId
     * @returns Coach Successful Response
     * @throws ApiError
     */
    public static getCoachCoachCoachIdGet(
        coachId: number,
    ): CancelablePromise<Coach> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/coach/{coach_id}',
            path: {
                'coach_id': coachId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Coach
     * @param coachId
     * @param requestBody
     * @returns Coach Successful Response
     * @throws ApiError
     */
    public static patchCoachCoachCoachIdPatch(
        coachId: number,
        requestBody: CoachPatch,
    ): CancelablePromise<Coach> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/coach/{coach_id}',
            path: {
                'coach_id': coachId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Coach
     * @param requestBody
     * @returns Coach Successful Response
     * @throws ApiError
     */
    public static createCoachCoachPost(
        requestBody: CoachCreate,
    ): CancelablePromise<Coach> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/coach/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Match Coaches
     * @param matchId
     * @param limit
     * @param offset
     * @returns MatchCoaches Successful Response
     * @throws ApiError
     */
    public static getMatchCoachesCoachMatchMatchIdGet(
        matchId: number,
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<MatchCoaches> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/coach/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Coaches
     * @param teamId
     * @param limit
     * @param offset
     * @returns CoachSmallList Successful Response
     * @throws ApiError
     */
    public static getTeamCoachesCoachTeamTeamIdGet(
        teamId: number,
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<CoachSmallList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/coach/team/{team_id}',
            path: {
                'team_id': teamId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Coach At Team
     * @param teamId
     * @param coachId
     * @param coachType
     * @returns CoachSmallList Successful Response
     * @throws ApiError
     */
    public static startCoachAtTeamCoachStartTeamTeamIdCoachCoachIdPost(
        teamId: number,
        coachId: number,
        coachType: CoachTypeEnum,
    ): CancelablePromise<CoachSmallList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/coach/start/team/{team_id}/coach/{coach_id}',
            path: {
                'team_id': teamId,
                'coach_id': coachId,
            },
            query: {
                'coach_type': coachType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Stop Coach To Team
     * @param teamId
     * @param coachId
     * @returns CoachSmallList Successful Response
     * @throws ApiError
     */
    public static stopCoachToTeamCoachStopTeamTeamIdCoachCoachIdPost(
        teamId: number,
        coachId: number,
    ): CancelablePromise<CoachSmallList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/coach/stop/team/{team_id}/coach/{coach_id}',
            path: {
                'team_id': teamId,
                'coach_id': coachId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Stop Coach To Team
     * @param teamFromId
     * @param teamToId
     * @param coachId
     * @param coachType
     * @returns CoachSmallList Successful Response
     * @throws ApiError
     */
    public static stopCoachToTeamCoachTransferCoachCoachIdFromTeamFromIdToTeamToIdPost(
        teamFromId: number,
        teamToId: number,
        coachId: number,
        coachType: CoachTypeEnum,
    ): CancelablePromise<CoachSmallList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/coach/transfer/coach/{coach_id}/from/{team_from_id}/to/{team_to_id}',
            path: {
                'team_from_id': teamFromId,
                'team_to_id': teamToId,
                'coach_id': coachId,
            },
            query: {
                'coach_type': coachType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Team Coach
     * @param teamCoachId
     * @returns Coach Successful Response
     * @throws ApiError
     */
    public static deleteTeamCoachCoachTeamCoachIdDelete(
        teamCoachId: number,
    ): CancelablePromise<Coach> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/coach/{team_coach_id}',
            path: {
                'team_coach_id': teamCoachId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Person
     * @param personId
     * @param activeTeamsOnly
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPersonPersonPersonIdGet(
        personId: number,
        activeTeamsOnly: boolean = true,
    ): CancelablePromise<(Player | Coach | Referee)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/person/{person_id}',
            path: {
                'person_id': personId,
            },
            query: {
                'active_teams_only': activeTeamsOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Image From Person
     * @param personId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteImageFromPersonPersonImagePersonIdDelete(
        personId: number,
    ): CancelablePromise<(string | null)> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/person/image/{person_id}',
            path: {
                'person_id': personId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
